$(document).ready(function() {
    initEventsTable();
    initLocLink();
    initResizeMap();
    initResizeFpContainer();

    hljs.initHighlightingOnLoad();


});

function initLocLink() {
    var $venueLoc = $("#venueLoc");
    var text = $venueLoc.text();
    var venueName = $venueLoc.data("name");
    var rawTerm = venueName + " " + text;
    var escapedTerm = EscapeGoogleTerm(rawTerm);
    var term = escapedTerm.replace(/\s/g, "+");
    var href = "https://www.google.com/maps/search/" + term;

    $venueLoc.attr("href", href);
}

function initEventsTable() {
    $(".event-row").on("click",
        function() {
            var $link = $(this).find(".event-link");
            var href = $link.attr("href");
            window.location.href = href;
        });
}


function updateArea() {
    var area = 0;

    $.each($(".hall-check:checked"),
        function (i, el) {
            area += $(el).data("area");
        });

    if (area > 0) {
        $("#halls-square-value").text(area.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
        $("#halls-square").removeClass("invisible");
    } else {
        $("#halls-square").addClass("invisible");
    }
}

function initResizeMap() {
    resizeMap();
    $(window).on("resize", resizeMap);
}

function resizeMap() {
    var $frame = $("#googleMapsFrame");
    var $container = $frame.parent();
    var width = $container.width();
    $frame.width(width);
    $frame.height(width / 16 * 7);
}

function initResizeFpContainer() {
    resizeFpContainer();
    $(window).on("resize", resizeFpContainer);
}

function resizeFpContainer() {
    var $cont = $("#fpContainer");
    var width = $cont.width();
    var height = width / 1.776;
    $cont.height(height);
}
